interface Category {
  id: string;
  name: string;
  icon: string;
  description: string;
  leadPrice: number;
  avgResponseTime: string;
  providerCount: number;
}

interface CategoryGridProps {
  categories: Category[];
  onCategorySelect: (categoryId: string) => void;
}

export default function CategoryGrid({ categories, onCategorySelect }: CategoryGridProps) {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            What Service Do You Need?
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Select a category below to get started with your free quote request
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => onCategorySelect(category.id)}
              className="bg-white border-2 border-gray-200 rounded-xl p-6 hover:border-emerald-500 hover:shadow-lg transition-all text-left group"
            >
              <div className="flex items-start gap-4 mb-4">
                <div className="w-14 h-14 bg-emerald-100 rounded-lg flex items-center justify-center group-hover:bg-emerald-500 transition-colors">
                  <i className={`${category.icon} text-2xl text-emerald-600 group-hover:text-white`}></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-gray-900 mb-1">
                    {category.name}
                  </h3>
                  <p className="text-sm text-gray-600">
                    {category.description}
                  </p>
                </div>
              </div>

              <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                <div className="flex items-center gap-4 text-sm text-gray-600">
                  <div className="flex items-center gap-1">
                    <i className="ri-user-line"></i>
                    <span>{category.providerCount}+ pros</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    <span>{category.avgResponseTime}</span>
                  </div>
                </div>
                <i className="ri-arrow-right-line text-xl text-emerald-500 group-hover:translate-x-1 transition-transform"></i>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}